export default function digiAccess() {
  function waitForDigiAccess(callback) {
    var checkInterval = setInterval(function () {
      if (typeof digiAccess !== 'undefined') {
        clearInterval(checkInterval);
        callback();
      }
    }, 100);
  }

  waitForDigiAccess(function () {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.matches('div.fa') || node.matches('span.fa'))) {
            if (node.style.fontFamily === 'Arial' && node.style.getPropertyPriority('font-family') === 'important') {
              node.style.removeProperty('font-family');
            }
          }
        });
        mutation.target.querySelectorAll('div.fa, span.fa').forEach(function (element) {
          if (element.style.fontFamily === 'Arial' && element.style.getPropertyPriority('font-family') === 'important') {
            element.style.removeProperty('font-family');
          }
        });
      });
    });

    const config = {childList: true, subtree: true, attributes: true, attributeFilter: ['style']};
    observer.observe(document.body, config);

    // Initial check for existing elements
    document.querySelectorAll('div.fa, span.fa').forEach(function (element) {
      if (element.style.fontFamily === 'Arial' && element.style.getPropertyPriority('font-family') === 'important') {
        element.style.removeProperty('font-family');
      }
    });
  });
}
